import { NavigationGuardWithThis } from 'vue-router';
import { useHThemePack } from '../composables/use-theme-pack';

/**
 * A navigation guard that reverts temporary themes when entering a route.
 *
 * @function
 * @name themeGuard
 * @description
 * This navigation guard is used to revert any temporary themes that might have been applied.
 * It ensures that the theme is reset to its original state upon entering a new route.
 *
 * @param {RouteLocationNormalized} to - The target Route Object being navigated to.
 * @param {RouteLocationNormalized} from - The current route being navigated away from.
 *
 * @returns {void}
 */
export const themeGuard: NavigationGuardWithThis<undefined> = () => {
  const { hRevertThemePack } = useHThemePack();

  // Revert temporary themes on route enter
  hRevertThemePack();
};
